import { render, staticRenderFns } from "./vue-simple-context-menu.vue?vue&type=template&id=499d3840&"
import script from "./vue-simple-context-menu.vue?vue&type=script&lang=js&"
export * from "./vue-simple-context-menu.vue?vue&type=script&lang=js&"
import style0 from "./vue-simple-context-menu.vue?vue&type=style&index=0&id=499d3840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports